<div class="size-64 p-low d-flex justify-content-center align-items-center position-relative">
  <div class="radius-rounded surface-back"></div>
  <img
    [src]="image()"
    class="category-image"
    [width]="size()"
  />
</div>
